import { render, staticRenderFns } from "./TableOrder.vue?vue&type=template&id=5b486948&scoped=true&"
import script from "./TableOrder.vue?vue&type=script&lang=js&"
export * from "./TableOrder.vue?vue&type=script&lang=js&"
import style0 from "./TableOrder.vue?vue&type=style&index=0&id=5b486948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b486948",
  null
  
)

export default component.exports